
import { register, findAll, applyAll } from '../../../../Javascript/Sysmex/Utils'

const PopupLink = el => {
  const popupLinks = findAll('[data-popuplink]')
  popupLinks.forEach(popupLink => {
    popupLink.addEventListener('click', (e) => {
      e.preventDefault()
      el.innerHTML = popupLink.dataset.popuplink
      applyAll(el)
    })
  })
}

register('PopupLink', PopupLink)
